import sha256 from 'sha256';

// const BASE_URL = `https://0e6qi2it6h.execute-api.us-east-2.amazonaws.com/api/v1/`;
const BASE_URL = 'https://staging-api-30920.shapshap.cards/v1/';
const API_KEY = 'awesome-secret';
const SECRET = 'a8Mwxw%#T6^et^uAK$p2EfS2cN!e53**8rA8$U*3';
const TIME_STAMP = new Date().getTime().toString();
const HASH = sha256(`${API_KEY}${TIME_STAMP}${SECRET}`);

export {BASE_URL, API_KEY, SECRET, TIME_STAMP, HASH};